// extracted by mini-css-extract-plugin
module.exports = {"modal":"Vv-z","emptySpace":"Wv-z","addItemButton":"Xv-z","plusCircle":"Yv-z","branchVisible":"Zv-z"};